import React from "react";
import { Table, Space, Card, Row, Col } from "antd";
import StringHelper from "../helpers/StringHelper";
import moment from "moment-jalaali";
import ContactUsModal from "./ContactUsModal";
import TicketsFilter from "./TicketsFilter";
import strings from '../../utils/strings';
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

export default function ContactUsTable({ filter }) {
  const general = useGeneralStore();
  const loading = general.tickets.loading;
  const ticketsList = general.tickets.data;

  const columns = [
    {
      title: " ",
      dataIndex: "operation",
      ellipsis: true,
      key: "operation",
      width: 120,
      render: (_, record) =>
        ticketsList.length >= 1 && (
          <Space size="middle">
            <button
              type="primary"
              htmltype="submit"
              className="btn btn-warning waves-effect waves-light"
              onClick={() => {
                general.ToggleContactUsModal(record);
                // setRequestId(record.Id);
              }}
            >
              پاسخ دهی
            </button>
          </Space>
        ),
    },
    {
      title: "کد ",
      dataIndex: "Id",
      width: 100,
      render: (text) => StringHelper.getFarsiNum(text),
    },
    {
      title: "نام",
      width: 170,
      dataIndex: "FullName",
    },
    {
      title: "موضوع",
      width: 200,
      dataIndex: "ContactUsTypeTitle",
    },
    {
      title: "تاریخ ثبت",
      width: 170,
      dataIndex: "CreateDate",
      render: (text) =>
        text &&
        StringHelper.getFarsiNum(moment(text).format("HH:mm - jYYYY/jM/jD")),
    },
    {
      title: "شماره همراه",
      dataIndex: "Tell",
      key: "Tell",
      width: 120,
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "شماره تلفن",
      dataIndex: "PhoneNo",
      key: "PhoneNo",
      width: 120,
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "ایمیل",
      dataIndex: "Email",
      key: "Email",
      width: 270,
    },
  ];

  return (
    <div className="animated fadeIn ">
      <div className="profile-header"></div>
      {filter &&
        <Card>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <TicketsFilter type="contact" />
            </Col>
          </Row>
        </Card>}
      <Table
        style={{ overflowX: "scroll", width: "100%" }}
        className="custom-table"
        showHeader={true}
        columns={columns}
        loading={loading}
        scroll={true}
        pagination={true}
        dataSource={ticketsList}
        rowKey="Id"
      />
      <ContactUsModal />
    </div>
  );
}
